import { render, staticRenderFns } from "./commodity-edit-form.html?vue&type=template&id=12541a44&scoped=true&"
import script from "./commodity-edit-form.ts?vue&type=script&lang=js&"
export * from "./commodity-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12541a44",
  null
  
)

export default component.exports